import * as React from "react";
import { ClientWizardStateStore } from "src/stores/wizard/ClientWizardStateStore";
import { observer, inject } from "mobx-react";
import { UitkCard } from "uitk-react-cards";
import { LobFormWithTabs } from "src/components/shared/StorefrontWizard/LobFormWithTabs/LobFormWithTabs.tsx";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";

export interface TabbedWizardCardProps {
  context?: ExtendedContextStore;
  wizardState: ClientWizardStateStore;
  wizardFormChildren: React.ReactElement[];
  wrappingClassNames?: string;
  cardClassNames?: string;
  cardContentClassNames?: string;
  tabGroupClassNames?: string;
  wizardFormClassNames?: string;
  trackOnChangeTab?: (tabName: string) => void;
}

/**
 * Returns a tabbed wizard within a uitk-card
 * Padding/styling of elements within card are handed down by parent region
 * Assumes any non-wizard form children are handled by parent region
 */
export const TabbedWizardCard: React.FunctionComponent<TabbedWizardCardProps> = inject(
  "wizardState",
  "context"
)(
  observer((props: TabbedWizardCardProps) => {
    if (!props.wizardState) {
      return null;
    }

    const wrappingClassNames = props.wrappingClassNames ? props.wrappingClassNames : "";
    const cardClassNames = props.cardClassNames ? props.cardClassNames : "";
    const cardContentClassNames = props.cardContentClassNames ? props.cardContentClassNames : "";
    const tabGroupClassNames = props.tabGroupClassNames ? props.tabGroupClassNames : "";
    const wizardFormClassNames = props.wizardFormClassNames ? props.wizardFormClassNames : "";
    const context = props.context;

    return (
      <div className={`wizardCard ${wrappingClassNames}`}>
        <UitkCard className={cardClassNames}>
          <div className={cardContentClassNames}>
            {props.wizardFormChildren?.length === 1 ? (
              props.wizardFormChildren
            ) : (
              <LobFormWithTabs
                context={context}
                lobForms={props.wizardFormChildren}
                wizardFormClassNames={wizardFormClassNames}
                tabGroupClassNames={tabGroupClassNames}
                trackOnChangeTab={props.trackOnChangeTab}
              />
            )}
          </div>
        </UitkCard>
      </div>
    );
  })
);
